import { CookieStorage } from 'aws-amplify/utils';

import { EncryptionKeyEnum } from '../../constants/encryption-key.ts';
import { CookieStorageData } from '../../types/storage.types.ts';

import { EncryptionUtil } from '../encryption.util.ts';

export class AwsCookieStorageUtil extends CookieStorage {
  constructor(
    data: CookieStorageData = {},
    private readonly encryptionUtil: EncryptionUtil = new EncryptionUtil(
      EncryptionKeyEnum.AWS_AUTH,
      EncryptionKeyEnum.AWS_AUTH_SALT
    )
  ) {
    super(data);
  }

  private extractKey(key: string): string {
    const splitKey = key.split('.');
    splitKey.splice(1, 1);

    return splitKey.join('.');
  }

  async setItem(key: string, value: string): Promise<void> {
    const encryptedValue = await this.encryptionUtil.encrypt(value);
    await super.setItem(this.extractKey(key), encryptedValue);
  }

  async getItem(key: string): Promise<string | null> {
    const result = await super.getItem(this.extractKey(key));
    if (result) {
      return this.encryptionUtil.decrypt(result);
    }

    return null;
  }

  async removeItem(key: string): Promise<void> {
    await super.removeItem(this.extractKey(key));
  }
}
